import type { GetSitemapContentQueryVariables } from "../generated/webapi.g";
import { sdk } from "./sdk";

export const getSitemapContent = (query: GetSitemapContentQueryVariables) =>
    sdk.GetSitemapContent.queryAsPromise(query).then(r => r.data?.pubsub?.query?.items || []);
